import clsx from 'clsx';
import dynamic from 'next/dynamic';
import { ComponentProps } from 'react';

const SearchBar = dynamic(() => import('./searchBar'), {
  ssr: false,
  loading: () => (
    <div
      className={clsx(
        ' absolute left-0 top-full h-[50px] w-full',
        'bg-white',
        'flex items-center justify-center gap-x-4',
      )}
    >
      <div className={clsx(' h-3 w-3 ', 'rounded-[50%] bg-E7DED5', 'animate-[loading-pulse_.6s_alternate_infinite]')} />
      <div
        className={clsx(' h-3 w-3 ', 'rounded-[50%] bg-E7DED5', 'animate-[loading-pulse_.6s_.2s_alternate_infinite]')}
      />
      <div
        className={clsx(' h-3 w-3 ', 'rounded-[50%] bg-E7DED5', 'animate-[loading-pulse_.6s_.4s_alternate_infinite]')}
      />
    </div>
  ),
});

let isLoaded = false;

const SearchBarLazyLoad = (props: ComponentProps<typeof SearchBar>) => {
  const { isSearchOpen } = props;

  if (isSearchOpen) {
    isLoaded = true;
  }

  return isLoaded && <SearchBar {...props} />;
};

export default SearchBarLazyLoad;
